import UserDataProvider from './UserDataProvider';
export default UserDataProvider;
